import { DEBUG, PATH } from '../constants';


const base = PATH;
const debug = DEBUG;

export async function getAllRepQcm() {
    try {
      const response = await fetch(base + 'rep-qcm');
      return await response.json();
    } catch (error) {
      console.error('Erreur getAllRepQcm', error);
      throw error;
    }
}
  
export async function getAllRepQcmByQuestion(q) {
    try {
      const response = await fetch(base + 'rep-qcm/q/' + q);
      return await response.json();
    } catch (error) {
      console.error('Erreur getAllRepQcmByQuestion', error);
      throw error;
    }
}

export async function insertNewReponse(reponseData) {
  try {
    const authToken = localStorage.getItem("authToken");
    // Création de l'objet FormData pour envoyer des fichiers
    const formData = new FormData();
    formData.append('id_question', reponseData.id_question);
    formData.append('is_true', reponseData.is_true);
    
    // Ajouter le texte si disponible
    if (reponseData.txt) {
      formData.append('txt', reponseData.txt);
    }
    
    // Si l'image est une chaîne base64 (pour les nouvelles images)
    if (reponseData.img && reponseData.img.startsWith('data:image')) {
      // Convertir base64 en Blob
      const fetchResponse = await fetch(reponseData.img);
      const blob = await fetchResponse.blob();
      formData.append('image', blob, 'image.jpg');
    } 
    // Si c'est un fichier direct
    else if (reponseData.img instanceof File) {
      formData.append('image', reponseData.img);
    }
    
    const response = await fetch(base + 'rep-qcm/insert', {
      method: 'POST',
      credentials: "include",
      headers: { 'Authorization': `Bearer ${authToken}` },
      body: formData
    });
    
    return await response.json();
  } catch (error) {
    console.error('Erreur insertNewReponse', error);
    throw error;
  }
}

export async function updateReponse(reponseData) {
  try {
    const authToken = localStorage.getItem("authToken");
    // Création de l'objet FormData pour envoyer des fichiers
    const formData = new FormData();
    formData.append('id', reponseData.id);
    formData.append('is_true', reponseData.is_true);
    
    // Ajouter le texte si disponible
    if (reponseData.txt) {
      formData.append('txt', reponseData.txt);
    }
    
    // Si l'image est une chaîne base64 (pour les nouvelles images)
    if (reponseData.img && reponseData.img.startsWith('data:image')) {
      // Convertir base64 en Blob
      const fetchResponse = await fetch(reponseData.img);
      const blob = await fetchResponse.blob();
      formData.append('image', blob, 'image.jpg');
    } 
    // Si c'est un fichier direct
    else if (reponseData.img instanceof File) {
      formData.append('image', reponseData.img);
    }
    // Si c'est une URL (image déjà sur le serveur)
    else if (reponseData.img && reponseData.img.startsWith('https://')) {
      // Ne pas envoyer l'image si c'est une URL existante et qu'on ne veut pas la changer
      // Alternativement, vous pourriez extraire et envoyer juste le chemin relatif si nécessaire
    }
    
    const response = await fetch(base + 'rep-qcm/update', {
      method: 'POST',
      credentials: "include",
      headers: { 'Authorization': `Bearer ${authToken}` },
      body: formData
    });
    
    return await response.json();
  } catch (error) {
    console.error('Erreur updateReponse', error);
    throw error;
  }
}

export async function deleteReponse(reponseId) {
  try {
    const authToken = localStorage.getItem("authToken");
    const formData = new FormData();
    formData.append('id', reponseId);
    
    const response = await fetch(base + 'rep-qcm/delete', {
      method: 'POST',
      credentials: "include",
      headers: { 'Authorization': `Bearer ${authToken}` },
      body: formData
    });
    
    return await response.json();
  } catch (error) {
    console.error('Erreur deleteReponse', error);
    throw error;
  }
}
    